const sxcore = [{
  desc: '寿险，所属基本法字典数据',
  options: {
    url: '/sales/basicLaw',
    method: 'get',
    baseURL: '/sxcore/api',
    needCustomMessage: true // 401/错误不弹全局框,调用方自行降级
  },
  vuex: false
}, {
  desc: '寿险，保单信息',
  options: {
    url: '/insurancePolicy',
    baseURL: '/sxcore/api'
  },
  vuex: false
}, {
  desc: '寿险，保单信息 列表合计',
  options: {
    url: '/insurancePolicy/listSum',
    baseURL: '/sxcore/api'
  },
  vuex: false
}, {
  desc: '寿险，业务员',
  options: {
    url: '/sales/policy',
    baseURL: '/sxcore/api'
  },
  vuex: false
}, {
  desc: '寿险，机构业绩报表查询供人管使用',
  options: {
    url: '/performanceReport/rBranchPerformance',
    baseURL: '/sxcore/api'
  },
  vuex: false
}, {
  desc: '寿险，组织业绩报表查询',
  options: {
    url: '/performanceReport/teamPerformance',
    baseURL: '/sxcore/api'
  },
  vuex: false
}, {
  desc: '寿险，人员详情组织业绩报表查询',
  options: {
    url: '/performanceReport/salesPerformance',
    baseURL: '/sxcore/api'
  },
  vuex: false
}, {
  desc: '寿险，薪酬列表',
  options: {
    url: '/saleSalary',
    baseURL: '/sxcore/basicLaw/api'
  },
  vuex: false
}, {
  desc: '寿险，薪酬项详情',
  options: {
    url: '/saleSalary',
    method: 'get',
    argsParams: true,
    baseURL: '/sxcore/basicLaw/api'
  },
  vuex: false
}]
export default sxcore



// WEBPACK FOOTER //
// ./src/api/sxcore.js